import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { ROUTES } from '../../common/constants';
import NewsLetters from './NewsLetters';

const NewsLetterWrapper = () => {
  return (
    <Switch>
      <Route exact path={ROUTES?.LEAD_GENS} component={NewsLetters} />
    </Switch>
  );
};

export default NewsLetterWrapper;
